import gql from 'graphql-tag'



export const DELETE_CATEGORY = gql`
    mutation deleteCategory($categoryId:String!){
        deleteCategory(categoryId:$categoryId){
            id
        }
    }
`